import { Accordion } from "@/components/ui/library/accordion";
import { useState } from "react";
import { useChildForm } from "@/features/leads/contexts/ChildProvider";
import { ChildItem } from "./ChildItem";

export default function EducationAccordan() {
  const [openValue, setOpenValue] = useState<string | undefined>(undefined);

  const { currentChildsOnSelectedStage } = useChildForm();
  const { child: activeChild } = useChildForm();

  return (
    <Accordion
      type="single"
      collapsible
      className="w-full"
      value={openValue}
      onValueChange={setOpenValue}
    >
      {currentChildsOnSelectedStage?.map((child: any) => {
        const childId = String(child.id);
        const isOpen = openValue === childId;
        const isCurrentChild = activeChild?.id === child.id;
        const enrichedChild = isCurrentChild
          ? { ...child, ...activeChild }
          : child;
        return (
          <ChildItem
            key={childId}
            child={enrichedChild}
            isOpen={isOpen}
            isCurrentChild={isCurrentChild}
          />
        );
      })}
    </Accordion>
  );
}
